export const globalStyles = {
  button: (isTv) => ({
    marginLeft: "10px",
    border: isTv ? "6px solid blue" : "2px solid blue",
    background: "transparent",
    color: "blue",
    fontFamily: "Lato",
    fontSize: isTv ? "60px" : "40px",
    padding: isTv ? "10px 25px" : "0px 20px",
    borderRadius: "20px",
    fontWeight: "700",
    margin: "10px 0px",
    cursor: "pointer",
  }),
};
